export default __webpack_public_path__ + "static/media/programmers-must-read-books.c7c21022.md";